import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { userLoginChallengeThunk, userLoginThunk } from "./thunk";

import { RootState } from "slices/store";
import { User } from '../../../models/user/user'
import { APIResult } from "models/api-results";

export interface AuthState {

    loggedInuser?: User,
    loading: boolean;
    sessionToken?: string;//used for otp validation
    token?: string;
    error?: string;
    success: boolean;
    /*    success: boolean;
       isUserLogout: boolean;
       user: string; */
}

export const initialState: AuthState = {
    loggedInuser: undefined,
    loading: false,
    sessionToken: "",
    token: "",
    error: "",
    success: false

};

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        logout(state: AuthState, action: PayloadAction) {
            state.loading = false;
            state.error = '';
            state.success = false;
            state.loggedInuser = undefined;
            state.sessionToken = '';
            state.token = '';
        },
        resetMessages(state: AuthState, action: PayloadAction) {
            state.error = '';
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        //Login
        builder.addCase(userLoginThunk.pending, (state) => {
            state.loading = true;
            state.error = "";

        });
        builder.addCase(userLoginThunk.fulfilled, (state, action) => {
            state.loading = false;
            const _apiData: APIResult<User | null> = action.payload
            state.loggedInuser = _apiData.data ?? undefined
            if ((action.payload?.status?.isError ?? false)) {
                state.error = action.payload?.status?.errorMessage ?? "Login failed"
            } else {
                state.token = action.payload?.meta?.token ?? "";
                state.sessionToken = action.payload?.meta?.sessionToken ?? "";

            }

        });
        /*  builder.addCase(userLoginThunk.rejected, (state) => {
             state.loading = false;
         }); */
        //Login with 2 f actor
        builder.addCase(userLoginChallengeThunk.pending, (state) => {
            state.loading = true;
            state.error = ""
        });
        builder.addCase(userLoginChallengeThunk.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                const _apiData: APIResult<User | null> = action.payload;

                if ((action.payload?.status?.isError ?? false)) {
                    state.error = action.payload?.status?.errorMessage ?? "Login failed"
                } else {
                    state.token = action.payload?.meta?.token ?? "";
                    state.sessionToken = action.payload?.meta?.sessionToken ?? "";
                    state.loggedInuser = _apiData.data ?? undefined
                }
            } else {
                state.error = "Something went wrong..."
            }


        });
        builder.addCase(userLoginChallengeThunk.rejected, (state) => {
            state.loading = false;
        });
    }
});

export const { logout, resetMessages } = loginSlice.actions;
export default loginSlice.reducer;
export const getAuthState = (store: RootState): AuthState => store.auth;
